import { ChallengeTask, ChallengeTaskCompletion } from '../types';
import { getTodayLocalDateOnly } from './date';

export type ChallengeCycleLabel = 'no desafio' | 'hoje' | 'na semana';

const getStartOfWeek = (date: Date): Date => {
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  const weekStart = new Date(date);
  weekStart.setDate(date.getDate() + diff);
  weekStart.setHours(0, 0, 0, 0);
  return weekStart;
};

const toLocalDateOnly = (date: Date): string => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getChallengeTaskTarget = (task: Pick<ChallengeTask, 'target_completions'>): number =>
  Math.max(1, Number(task.target_completions) || 1);

export const getChallengeCycleLabel = (frequency?: ChallengeTask['frequency']): ChallengeCycleLabel => {
  if (frequency === 'daily') return 'hoje';
  if (frequency === 'weekly') return 'na semana';
  return 'no desafio';
};

export const getCurrentChallengeCycleKey = (frequency?: ChallengeTask['frequency']): string => {
  if (frequency === 'daily') {
    return getTodayLocalDateOnly();
  }

  if (frequency === 'weekly') {
    return toLocalDateOnly(getStartOfWeek(new Date()));
  }

  return 'once';
};

export const getChallengeTaskProgress = (
  task: Pick<ChallengeTask, 'frequency' | 'target_completions'>,
  completions: ChallengeTaskCompletion[]
) => {
  const targetCompletions = getChallengeTaskTarget(task);
  const currentCycleKey = getCurrentChallengeCycleKey(task.frequency);
  const cycleLabel = getChallengeCycleLabel(task.frequency);
  const totalCompleted = completions.length;
  const currentCycleCompletions = task.frequency === 'once'
    ? totalCompleted
    : completions.filter((completion) => completion.completion_date === currentCycleKey).length;
  const currentCycleTarget = task.frequency === 'once' ? targetCompletions : 1;
  const isCompletedInCurrentCycle = currentCycleCompletions >= currentCycleTarget;
  const isFullyCompleted = totalCompleted >= targetCompletions;

  return {
    totalCompleted,
    targetCompletions,
    currentCycleCompletions,
    currentCycleKey,
    cycleLabel,
    isCompletedInCurrentCycle,
    isFullyCompleted
  };
};

